var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuideIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 21,
    viewBox: "0 0 39 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 37,
    height: 20,
    rx: 5.33,
    fill: "#F7F7F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 37,
    height: 20,
    rx: 5.33,
    stroke: "#D7D8E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_2789)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1875 6.125C20.1875 5.76256 19.8797 5.46875 19.5 5.46875C19.1203 5.46875 18.8125 5.76256 18.8125 6.125L18.8125 13.7282L14.4861 9.59846C14.2177 9.34218 13.7823 9.34218 13.5139 9.59846C13.2454 9.85474 13.2454 10.2703 13.5139 10.5265L19.0139 15.7765C19.0798 15.8395 19.1557 15.8869 19.2368 15.919C19.3161 15.9503 19.4027 15.9679 19.4937 15.9687C19.4958 15.9687 19.4979 15.9688 19.5 15.9688C19.5021 15.9688 19.5042 15.9687 19.5063 15.9687C19.6929 15.9671 19.8618 15.8945 19.9847 15.7779C19.9852 15.7775 19.9857 15.777 19.9861 15.7765L19.9863 15.7763L19.9866 15.7761L25.4861 10.5265C25.7546 10.2703 25.7546 9.85474 25.4861 9.59846C25.2177 9.34218 24.7823 9.34218 24.5139 9.59846L20.1875 13.7282L20.1875 6.125Z",
    fill: "#585971"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_2789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "white",
    transform: "translate(8.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideIcon3);
export default __webpack_public_path__ + "static/media/guide-icon-3.de17b1a446f6abd43ba780deea2c4475.svg";
export { ForwardRef as ReactComponent };